import styled from 'styled-components';

export const StyledContact = styled.section`
  background-color: var(--dark-bg);
  padding: 100px 0;

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  h2 {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 50px;
    color: var(--text-color);
    font-family:gunar thin, sans-serif;
    font-weight: bold; 
    letter-spacing: 0.1em;

    .highlight {
      color: var(--primary-color);
    }
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 30px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    font-size: 1rem;
    text-decoration: none;
    
    &.btn-primary {
      background-color: var(--primary-color);
      color: var(--light-text);
      position: relative;
      overflow: hidden;
      
      &:hover {
        background-color: var(--primary-dark);
        transform: translateY(-3px);
      }
    }
  }
`;

export const ContactContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const ContactForm = styled.div`
  background-color: var(--card-bg);
  border-radius: 8px;
  padding: 40px;
  box-shadow: var(--box-shadow);

  form {
    display: flex;
    flex-direction: column;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: var(--text-color);
  }

  input, textarea {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    background-color: var(--input-bg);
    color: var(--text-color);
    font-size: 1rem;
    transition: all 0.3s ease;

    &:focus {
      border-color: var(--primary-color);
      outline: none;
      box-shadow: 0 0 0 2px rgba(255, 107, 0, 0.2);
    }
  }

  textarea {
    resize: vertical;
  }
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--card-bg);
  border-radius: 8px;
  padding: 25px;
  box-shadow: var(--box-shadow);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  .icon {
    width: 60px;
    height: 60px;
    background-color: rgba(255, 107, 0, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    font-size: 1.5rem;
    color: var(--primary-color);
  }

  .text {
    h3 {
      margin-bottom: 5px;
      color: var(--text-color);
    }

    p {
      margin: 0;
      color: var(--text-secondary);
    }

    a {
      color: var(--primary-color);
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
